import React, { memo } from "react";

const FilterSection = memo(({ shade, group, color, properties }) => {
	const handleCheckboxChange = (setter) => (event) => {
		setter(event.target.checked);
	};

	const noSpecialProperyShades = ["Simply Cellular", "Cellular"];

	return (
		<div className="justify-center mt-4 mb-4 w-full">
			<div className="flex flex-col items-center py-18 w-full">
				<div className="w-full flex justify-around py-2 max-md:w-11/12 max-md:block max-md:px-4">
					<label
						htmlFor="shadeType"
						className="text-xl font-semibold text-black mx-2 w-1/5 max-lg:w-1/2"
					>
						<span className="mx-2 text-xl!important text-[#ED7125] max-md:hidden">
							•
						</span>
						<span className="label">Shade Type</span>
					</label>
					<select
						name="shadeType"
						id="shadeType"
						value={shade.selected}
						onChange={(e) => shade.setSelected(e.target.value)}
						className="px-4 py-3 border border-gray-300 w-1/3 max-md:w-full max-md:my-4 text-lg"
					>
						<option value="roller">Roller</option>
						<option value="interlude">Interlude</option>
						<option value="illusion">Illusion</option>
						<option value="Simply Cellular">Simply Cellular</option>
						<option value="Day And Night Cellular">Cellular</option>
						<option value="Exterior">Onex Zip Screen</option>
					</select>
				</div>

				<div className="w-full flex justify-around py-2 max-md:w-11/12 max-md:block max-md:px-4">
					<label
						htmlFor="transparency"
						className="text-xl font-semibold text-black mx-2 w-1/5 max-md:w-full max-lg:w-1/2"
					>
						<span className="mx-2 text-xl text-[#ED7125] max-md:hidden">•</span>
						<span className="label">Fabric Transparency</span>
					</label>
					<select
						name="transparency"
						id="transparency"
						value={group.selected}
						onChange={(e) => group.setSelected(e.target.value)}
						className="px-4 py-3 border border-gray-300 w-1/3 max-md:w-full max-md:my-4 text-lg"
					>
						{group.list.map((element, index) => (
							<option key={index} value={element}>
								{element}
							</option>
						))}
					</select>
				</div>

				<div className="w-full flex justify-around py-2 max-md:w-11/12 max-md:block max-md:px-4">
					<label
						htmlFor="shadeColour"
						className="text-xl font-semibold text-black mx-2 w-1/5 max-lg:w-1/2 max-md:w-full"
					>
						<span className="mx-2 text-xl text-[#ED7125] max-md:hidden">•</span>
						<span className="label">Fabric Colour</span>
					</label>
					<select
						name="shadeColour"
						id="shadeColour"
						value={color.selected}
						onChange={(e) => color.setSelected(e.target.value)}
						className="px-4 py-3 border border-gray-300 w-1/3 max-md:w-full max-md:my-4 text-lg"
					>
						{color.list.map((element, index) => (
							<option key={index} value={element}>
								{element}
							</option>
						))}
					</select>
				</div>

				{!noSpecialProperyShades?.includes(shade.selected) && (
					<div className="w-full flex justify-around py-2 max-md:w-11/12 max-md:block max-md:px-4">
						<label className="text-xl font-semibold text-black mx-2 w-1/5 max-md:w-full max-lg:w-1/2">
							<span className="mx-2 text-xl text-[#ED7125] max-md:hidden">
								•
							</span>
							<span className="label">Special Property</span>
						</label>
						<div className="px-4 py-3 border border-gray-300 w-1/3 max-md:w-full max-md:my-4 text-lg">
							{Object.entries(properties).map(
								([key, { checked, setChecked }]) => (
									<div key={key}>
										<input
											type="checkbox"
											id={key}
											checked={checked}
											onChange={handleCheckboxChange(setChecked)}
											className="mr-4"
										/>
										<label htmlFor={key}>
											{key.charAt(0).toUpperCase() + key.slice(1)}
										</label>
									</div>
								)
							)}
						</div>
					</div>
				)}
			</div>
		</div>
	);
});

FilterSection.displayName = "FilterSection";

export default FilterSection;
